module.exports = __webpack_public_path__ + "school/img/duomeiDetailBg.f7f9fdbd.jpg";